<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
    <FooterBar />
    <ButtonToTop />
  </div>
</template>

<script>
import FooterBar from '@/components/Footer'
import ButtonToTop from '@/components/ButtonToTop'
export default {
  name: 'App',
  components: {
    FooterBar, ButtonToTop
  }
}
</script>

<style lang="scss">
@import url('./styles/index.scss');
</style>



// WEBPACK FOOTER //
// src/App.vue